/**
 * Is this store-save refusal about the Checkout section's slice?
 *
 * The server refuses the whole store save (HTTP 400) when the Checkout
 * section's ``checkout_fields`` / ``shipping_mode`` / ``ship_to_department_id``
 * cannot be saved (for example removing a checkout field from a store with
 * orders). The store editor then puts the SAVED Checkout state back on
 * screen and says why inside the section (Bug Intake #450), instead of
 * leaving the refused choice showing as if it were saved.
 *
 * The prefixes live in checkoutSaveRefusals.json, which the backend contract
 * test (api/tests/test_checkout_save_refusals_contract.py) checks against
 * the messages the real model raises.
 */
import refusals from "./checkoutSaveRefusals.json";

export function isCheckoutSaveRefusal(message) {
  if (typeof message !== "string") return false;
  return refusals.prefixes.some((prefix) => message.startsWith(prefix));
}
